import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const explore = ['Explore all six volumes', 'Review the diagnostic workflows', 'Examine the fault code reference materials', 'Study the illustrated cases', 'Review the live data interpretation guides', 'Download the diagnostic worksheets', 'Decide whether the system fits your needs'];
export function Guarantee() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-150" data-mp="19f0n14b6sard">
      <div className="mx-auto max-w-3xl text-center" data-id="element-151" data-mp="14h8xggy0l0qc">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-ok bg-[#08180F]" data-id="element-152" data-mp="1j52d21n3o38x">
          <ShieldCheckIcon className="h-9 w-9 text-ok" aria-hidden="true" data-id="element-153" data-mp="1ed26vrgfse3w" />
          <span className="font-display text-2xl font-extrabold leading-none text-white" data-id="element-154" data-mp="qnhmd44mx8si">7 DAYS</span>
        </div>
        <h2 id="guarantee-title" className="mt-6 font-display text-4xl font-extrabold uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-155" data-mp="lo4wsbmdpnm8">
          7-day money-back <span className="text-ok" data-id="element-156" data-mp="txt8n0572lde">guarantee</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-mist" data-id="element-157" data-mp="tw9rz8fmm8b3">
          Explore the Blueprint and decide whether it fits your diagnostic work. Once you receive access, you can:
        </p>

        <ul className="mx-auto mt-8 max-w-md space-y-2.5 text-left" data-id="element-158" data-mp="60nktin9feg2">
          {explore.map(item => <li key={item} className="flex items-start gap-3 text-[16px] text-white" data-id="element-159" data-mp="azgvz4f2qtd2">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-160" data-mp="f1bwi6p6l2ps" />
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-xl text-[16px] leading-relaxed text-mist" data-id="element-161" data-mp="k1q7nxm2wss1">
          If it’s not right for you, request a refund within seven days of purchase according to the published
          refund terms. <strong className="text-white" data-id="element-162" data-mp="1vhomyj7uob1p">Your purchase is protected.</strong>
        </p>

        <CtaButton className="mt-10" label="Get the Blueprint risk-free" sub="7-day guarantee · $27 one-time" data-id="element-163" data-mp="3rgx4gxu6ohh2" />
      </div>
    </section>;
}